export default "__VITE_ASSET__C7Xm5JIx__"